<template>
  <div class="dbsz">
    <p class="title">打标设置 参考值为系统按照中英、英中项目统计计算的，请根据自己项目实际情况填写。</p>
    <div style="display: flex">
      <el-form :model="childConfigInfo" :rules="rules" ref="childConfigInfo" label-width="180px"
               class="demo-ruleForm"
               v-loading="loading">
        <el-form-item label="打标价格" prop="pePrice">
          <el-input-number :controls="true" v-model="childConfigInfo.markingPrice" :precision="2"
                           :min="0.01"
                           :max="100000"
                           :disabled="childConfigInfo.isConfigDisabled" placeholder="请输入打标价格"
                           size="medium"></el-input-number>
          <span class="input-company">元/千字</span>
          <p class="input-note" v-if="status === 1 && markingRecommend.markingPrice">
            推荐价格：{{ markingRecommend.markingPrice }}元/千字</p>
        </el-form-item>
        <el-form-item label="任务截止时间" prop="limitTime" class="m-t-20">
          <el-date-picker
            v-model="childConfigInfo.limitTime"
            :disabled="childConfigInfo.isConfigDisabled"
            type="datetime"
            format='yyyy-MM-dd HH:mm'
            valueFormat='timestamp'
            :pickerOptions="this.pickerOptions"
            placeholder="选择任务截止时间">
          </el-date-picker>
          <p class="input-note">（任务截止时间前无特殊情况，请勿结束任务，否则将造成译员损失）</p>
        </el-form-item>
        <hr>
        <p class="title">此设置任务进行中可以修改<span></span></p>

        <el-form-item label="规则配置" prop="remark">
          <el-input :disabled="childConfigInfo.isRemarkDisabled" type="textarea" rows="6"
                    resize="none"
                    v-model="childConfigInfo.remark" style="width: 420px;" :maxlength="1000"

          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="!childConfigInfo.isConfigDisabled && permissions.dot_flow_start "
                     size="medium" type="primary"
                     @click="submitForm('childConfigInfo')">开始打标
          </el-button>
          <el-button
            v-if="childConfigInfo.isConfigDisabled && !childConfigInfo.isRemarkDisabled && permissions.dot_flow_start"
            size="medium"
            type="primary" @click="saveRemark('childConfigInfo')">保存
          </el-button>
        </el-form-item>
      </el-form>

      <el-card class="box-card" style="background-color: #fff">
        <div class="text item" style="text-align: center;font-size: 30px">
          公告
        </div>
        <div>
          DOT属于大规模协同工作，任务一旦开始无法中断，请各位PM确认开始任务之前务必在订单详情中检查机翻稿是否存在以下问题：
        </div>
        <div>
          1、存在因为排版原因造成的断句偏差很大
        </div>
        <div>
          2、存在因为解析问题，如造成原文中特殊符号、单位等偏差很大
        </div>
        <div>
          3、存在术语加持失败，造成译文质量很差
        </div>
        <div>
          4、存在机翻译文有遗漏
        </div>
        <div>
          如存在以上任一问题，建议暂停轻任务配置，联系相关人员分析处理；
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {dabiaoStart, configList} from '@/api/dot/marking'
import {saveRemark} from '@/api/dot/flow'
import {recommend} from '@/api/dot/order'
import {mapGetters} from "vuex";
import {alertErroMsg, alertSuccessMsg} from "@/util/commonMsg";

export default {
  props: ['configInfo', 'orderId', 'status'],
  data() {
    return {
      hasLoad: false,
      childConfigInfo: this.configInfo,
      submitText: "开始打标",
      submitBtn: true,
      defaultRemark: "1.轻任务打标模式是一种分布式的在线打标方式，是指将一份大型稿件通过AI拆分成多个任务包，由若干译员分别在原有翻译结果的基础上进行译文准确度的结果标注，再由AI合稿的打标模式；\n" +
        "2.为使术语统一，页面上可能会有相应的术语提示，请按规定使用术语判断译文结果。\n" +
        "3.任务包提交后必须通过审核后方可计入预计收益，当整个众包任务订单被下单人确认后，预计收益计入可结算收益，待账期结束后，收益可自动入账并可提现；\n" +
        "4.对于恶意破坏平台正常任务派发交付的行为，将按照语翼12分规则进行处罚。",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      markingRecommend: {},
      dic: [],
      sizeValue: 'small'
    }
  },
  created() {
    configList().then(res => {
      this.dic = res.data.data
    })
  },

  mounted() {
    recommend(this.orderId, 1).then(res => {
      this.markingRecommend = res.data.data
    })
  },

  computed: {
    option() {
      return {
        size: this.sizeValue,
        submitText: this.submitText,
        submitBtn: this.submitBtn,
        printBtn: false,
        emptyBtn: false,
        refreshBtn: false,
        labelWidth: "120",
      }
    },
    ...mapGetters(['permissions']),
  },
  watch: {
    'configInfo': function (n, o) {
      this.childConfigInfo = n
      if (this.childConfigInfo.isConfigDisabled) {
        this.submitText = "保存"
      }
      if (this.childConfigInfo.isRemarkDisabled) {
        this.submitBtn = false
      }

    }
  },
  updated() {

    if (this.childConfigInfo.status === 1 && !this.hasLoad) {
      this.hasLoad = true
      recommend(this.childConfigInfo.orderId, 1).then(res => {
        this.markingRecommend = res.data.data
      })

    }
  },
  methods: {
    saveRemark(form) {
      let remark = this.$refs[form].model.remark
      if (remark == null || remark.length === 0) {
        this.$message.error("请填写任务规则")
        this.loading = false
        return;
      }
      this.loading = true
      saveRemark({flowId: this.$route.params.id, remark: remark}).then(response => {
        if (response.data.data.code > 0) {
          alertSuccessMsg()
        } else {
          alertErroMsg(response.data.data.msg)
        }
      })
    },
    dabiaoStart(form) {
      if (this.$refs[form].model.limitTime < Date.now()) {
        this.$message.error("不可选择过去时间")
        this.loading = false
        return;
      }
      dabiaoStart(Object.assign(this.$refs[form].model, {flowId: this.$route.params.id})).then(response => {
        if (response.data.data > 0) {
          alertSuccessMsg("打标任务创建成功")
        } else if (response.data.data === -4) {
          alertErroMsg("打标任务创建失败,没有生成聚合文件")
        } else {
          alertErroMsg("打标任务创建失败")
        }
      })
    },

    submitForm(form) {
      if (this.$refs[form].model.markingPrice == null) {
        this.$message.error("请输入打标价格")
        this.loading = false
        return;
      }
      if (this.$refs[form].model.limitTime == null) {
        this.$message.error("请输入任务截止时间")
        this.loading = false
        return;
      }
      if (this.$refs[form].model.limitTime < Date.now()) {
        this.$message.error("不可选择过去时间")
        this.loading = false
        return;
      }
      if (this.$refs[form].model.remark == null || this.$refs[form].model.remark.length === 0) {
        this.$message.error("请填写任务规则")
        this.loading = false
        return;
      }
      if (this.$refs[form].model.markingPrice < 1) {
        this.$alert(`您填写的价格远低于平台平均价格，确定提交？`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.dabiaoStart(form)
            }
          },
        });
      } else {
        this.dabiaoStart(form)
      }


    },
  },
  filters: {},
}

</script>
<style lang="scss">
.dbsz {
  .title {
    padding-left: 30px;
    font-size: 14px;
    margin-bottom: 30px;

    span {
      padding-left: 10px;
      font-size: 12px;
    }
  }

  // .el-form-item{
  //   .el-form-item__label{
  //     width: 125px !important;
  //   }
  //   .el-form-item__content{
  //     margin-left: 125px !important;
  //   }
  // }
}

.input-note {
  font-size: 12px;
  color: #909399;
  margin: 0;
  line-height: 1.5;
  padding-top: 10px;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  right: 8px;
}
</style>

